import React, { Fragment, useEffect, useState, useMemo, useRef } from "react";
import Loader from "../Loader/Loader";

import { GET_PDP_BUNDLE } from "../../api/query";
import axios from "axios";
import { animate } from "motion";
import "../Product/Product.scss";
import VideoPlaceholder from "../ProductVideo/VideoPlaceholder";
import { SRLWrapper, useLightbox } from "simple-react-lightbox";
import CaretUp from "../Caret/CaretUp";
import CaretDown from "../Caret/CaretDown";
import { ErrorBoundary } from "react-error-boundary";
import {
  slugify,
  getUniqueListBy,
  insertUrlParam,
  unslugify,
  sizeSortFunc,
  convertToCurrency,
} from "../../helpers/helpers";
import SizeGuide from "../SizeGuide/SizeGuide";
import { act } from "@testing-library/react";




const FILES_URL = "https://cdn.shopify.com/s/files/1/2338/2917/files/";

function getSessionStorageOrDefault(key, defaultValue) {
  const stored = sessionStorage.getItem(key);
  if (!stored) {
    return defaultValue;
  }
  return JSON.parse(stored);
}

let slug = window.location.href.split("/").pop();

slug = slug.split("?")[0];

const tagsArray = ["Buy2Get25", "Buy3Get30", "Buy3Get35", "warehousesale"];

const apiReq = "https://registry-api.lilhathee.com/api/graphql";

const BOOST_URL =
  "https://services.mybcapps.com/bc-sf-filter/search?shop=monicaandandyonline.myshopify.com&limit=70&variant_available=true&build_filter_tree=true";

// let strProduct = productIds.join(" OR ");
// const result = await axios(`${boostLiveUrl}&q=${strProduct}`);

const BundleProduct = React.memo(
  ({
    products,
    mainProduct,
    hiddenProduct,
    variants,
    variantIdOnLoad,
    allVariants,
  }) => {
    const [loader, setLoader] = useState(false);
    const [productTitle, setProductTitle] = useState("");
    const [activeVariant, setActiveVariant] = useState(0);
    const [mainImage, setMainImage] = useState(
      ""
      // src: productImageSrc,
      // alt: productTitle ? productTitle : 'product image',
      // initial_color:
      //     variants[0].initial_color ||
      //     mainProduct[0].options_with_values[0].values[0].title,
    );
    const [allVariantImages, setAllVariantImages] = useState([]);

    const [currentImages, setCurrentImages] = useState();
    // matchingProductImages
    const [position, setPosition] = useState({
      pos: 0,
      index: 0,
    });
    const [mainImageStyle, setMainImageStyle] = useState({
      backgroundImage: "",
      backgroundPosition: "0% 0%",
    });

    const { openLightbox, closeLightbox } = useLightbox();
    const [productDescription, setProductDescription] = useState("");
    const [varaintColor, setVariantColor] = useState([]);
    const [sizeArray, setSizeArray] = useState([]);
    const inputRef = useRef(null);
    const [currentSize, setCurrentSize] = useState({
      size: "",
      variantId: "",
      sku: "",
    });
    const [price, setPrice] = useState([]);

    useEffect(() => {
      setLoader(true);

      let reqData = {
        query: GET_PDP_BUNDLE,
        variables: {
          slug: "summer-bundle",
        },
      };
      axios
        .post(apiReq, reqData)
        .then((res) => {
          if (res.status === 200 && res.data?.data?.pdpBundleBox) {
            let bundleData = res.data?.data?.pdpBundleBox.edges[0].node;
            setProductTitle(bundleData["title"]);
            let allVariantsImages = bundleData.bundles.map((item) => {
              return [item.heroImage, item.heroImage1, item.heroImage2].filter(
                (data) => data !== null
              );
            });
            setAllVariantImages(allVariantsImages);
            setMainImage(allVariantsImages[0][0]);
            setProductDescription(bundleData.description);

            let productIds = bundleData.bundles.map((bundle) => {
              return [
                bundle.bundleProducts.map((i) => {
                  return i.shopifyProductId;
                }),
              ];
            });

            productIds.map(async (idList, index) => {
              await getShopifyProducts(idList, index);
            });
            setLoader(false);
          }
        })
        .catch((err) => console.log(err));
    }, []);

    const getShopifyProducts = async (idList, index) => {
      // short shirt oxford shirt white - 6937138561086 , "Oxford Sport Short Bundle_White" = 6940979888190
      //   let idStr = [6940979888190, 6937138561086].join(" OR ");
      let idStr = idList[0].join(" OR ");
      const result = await axios(`${BOOST_URL}&q=${idStr}`);

      let data = result.data;
      let color =
        data.products.length > 0
          ? data.products.filter((obj) => obj.id == idList[0][0])[0][
              "variants"
            ][0]["initial_color"]
          : "";
      let colorList = varaintColor;
      colorList[index] = color;
      console.log("----------");

      console.log("----------");

      setVariantColor(colorList);

      //   let price = data.products.reduce((products, a) => partialSum + a, 0);

      //Get total price for one variant
      let totalPrice = data.products.reduce(
        (n, { price_max }) => n + price_max,
        0
      );
      let priceArray = price;
      priceArray[index] = totalPrice;
      setPrice(priceArray);

      let manageSizes = data.products.map((item) => {
        let initialSizes = [];

        item.variants.map((v) => {
          if (v.initial_size) {
            initialSizes.push({
              variantId: v.id,
              inventory_quantity: v.inventory_quantity,
              sku: v.sku,
              productId: v.product_id,
              price: v.price,
              initial_size: v.initial_size,
            });
          }
          return null;
        });

        // console.log('initialSizes', initialSizes)

        if (initialSizes.length > 0) {
          let sortedSizeList = initialSizes.sort(sizeSortFunc);

          sortedSizeList = getUniqueListBy(sortedSizeList, "initial_size");

          sortedSizeList = sortedSizeList.filter(function (e) {
            return e !== null && e !== undefined && e !== "";
          });

          if (sortedSizeList) {
            return sortedSizeList;
          }
        } else {
          console.error("Something went wrong");
        }
      });

      let sizes = sizeArray;
      sizes[index] = manageSizes;
      setSizeArray(sizes);
    };

    const options = {
      settings: {
        overlayColor: "rgba(248, 248, 248, 0.9)",
      },
    };

    const handleMouseMove = (e, src) => {
      if (window.screen.width < 768) {
        return;
      }
      const { left, top, width, height } = e.target.getBoundingClientRect();
      const x = ((e.pageX - left) / width) * 100;
      const y = ((e.pageY - top) / height) * 100;
      setMainImageStyle({
        backgroundImage: `url(${src})`,
        backgroundPosition: `${x}% ${y}%`,
      });
    };

    const handleLightbox = () => {
      // closeLightbox()
      // let imageSelected = document.querySelector('.image-selected')
      // let currentIndex = imageSelected.dataset.index
      // currentIndex = parseInt(currentIndex)
      // openLightbox(currentIndex ? currentIndex : 0)
    };

    const handlePrevClick = () => {
      if (position.index === 0) {
        return;
      }
      if (position.index !== 0) {
        animate(
          "#images-nav",
          { y: position.pos + 90 },
          { duration: 0.5 }
        ).finished.then(() => {
          // console.log('prev click finished')
          setMainImage(allVariantImages[activeVariant][position.index - 1]);

          setPosition({
            pos: position.pos + 90,
            index: position.index - 1,
          });
        });
      }
    };

    const handleNextClick = () => {
      if (position.index === allVariantImages[activeVariant].length - 1) {
        return;
      }

      let imageSelected = document.querySelector(".image-selected");

      let currentIndex = imageSelected.dataset.index.slice(1);
      console.log(currentIndex);

      currentIndex = parseInt(currentIndex);

      console.log("currentIndex, imageSelected", currentIndex);

      imageSelected.classList.remove("image-selected");

      // find matching image node; add class
      let matchingImageNode = document.querySelector(
        '.nav-image[data-index="' + `${activeVariant}${currentIndex + 1}` + '"]'
      );
      matchingImageNode.classList.add("image-selected");
      console.log(matchingImageNode);
      // console.log('currentImages', currentImages, position.index + 1)

      if (currentIndex !== allVariantImages[activeVariant].length) {
        animate(
          "#images-nav",
          { y: position.pos - 90 },
          { duration: 0.5 }
        ).finished.then(() => {
          // console.log('next click finished')
          setMainImage(allVariantImages[activeVariant][currentIndex + 1]);
          setPosition({
            pos: position.pos - 90,
            index: currentIndex + 1,
          });
        });
      }
    };

    const handleSizeClick = (size, variantId, index, sku, inventory) => {
      let el = document.querySelectorAll(".registry-actions");
      el[0].firstChild.innerText = "Add to Registry";
      let ele = document.getElementsByClassName("size size-selected");
      if (ele.length > 0) {
        ele[0].classList.remove("size-selected");
      }
      setCurrentSize({
        size: size,
        variantId: variantId,
        sku: sku,
      });
    };

    const handleImageClick = (index) => {
      closeLightbox();

      let imageSelected = document.querySelector(".image-selected");

      imageSelected.classList.remove("image-selected");

      // find matching image node; add class
      let matchingImageNode = document.querySelector(
        '[data-index="' + `${activeVariant}${index}` + '"]'
      );
      matchingImageNode.classList.add("image-selected");

      setMainImage(allVariantImages[activeVariant][index]);

      setPosition({
        ...position,
        index: index,
      });
    };

    const handleAddToCart = (e) => {
      e.preventDefault();

      // get the variantId of the product we are embroidering
      // console.log('variantId', variantId)

      // prepare data for Shopify

      let variantIds = sizeArray[activeVariant].map((obj) =>
        obj.filter((s) => s.initial_size === currentSize.size)
      );

      let timestamp = new Date().getTime();

      let shopifyData = variantIds.flat().map((data) => {
        return {
          id: data.variantId,
          quantity: 1,
          properties: {
            bundleTitle: productTitle + "_" + timestamp,
            bundlePrice: price[activeVariant],
            total: sizeArray[activeVariant].length,
          },
        };
      });

      // prepare data for Shopify
      let formData = {
        items: shopifyData,
      };
      console.log(formData);
      fetch(window.Shopify.routes.root + "cart/add.js", {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
        },
        body: JSON.stringify(formData),
      })
        .then((response) => {
          // console.log('response', response)
          setTimeout(() => {
            document.getElementById("open-cart-drawer").click();
          }, 500);
          return response.json();
        })
        .catch((error) => {
          console.error("Error:", error);
        });
    };

    return (
      <>
        {loader ? (
          <Loader />
        ) : (
          <Fragment>
            <div className="product-outer main-product pt-3">
              <div className="product-inner">
                <div className="product-images-outer">
                  <div className="product-images-inner">
                    <div className="nav-images">
                      {mainImage.length > 0 ? (
                        <Fragment>
                          <div
                            className={`nav-prev nav-arrow ${
                              position.pos === 0 ? "nav-disabled" : null
                            }`}
                            onClick={handlePrevClick}
                          >
                            <CaretUp />
                          </div>
                          <div className="nav-images-wrap">
                            <ul id="images-nav" className="images-nav nostyle">
                              <SRLWrapper options={options}>
                                {allVariantImages[activeVariant] &&
                                  allVariantImages[activeVariant].map(
                                    (img, i) => {
                                      return (
                                        <li
                                          key={i}
                                          data-index={`${activeVariant}${i}`}
                                          // data-color={n.initial_color}
                                          className={`nav-image ${
                                            position.index === i
                                              ? "image-selected"
                                              : null
                                          }`}
                                          onClick={() => handleImageClick(i)}
                                          // title={n.initial_color}
                                        >
                                          <a href={img}>
                                            <img src={img} alt="variant-img" />
                                          </a>
                                        </li>
                                      );
                                    }
                                  )}
                              </SRLWrapper>
                            </ul>
                          </div>
                          <div
                            className={`nav-next nav-arrow ${
                              position.index ===
                              allVariantImages[activeVariant].length
                                ? "nav-disabled"
                                : null
                            }`}
                            onClick={handleNextClick}
                          >
                            <CaretDown />
                          </div>
                        </Fragment>
                      ) : (
                        <div className="loading">Loading</div>
                      )}
                    </div>
                    <div
                      className="product-image main-image"
                      onMouseMove={(e) => handleMouseMove(e, mainImage)}
                      style={mainImageStyle}
                      onClick={handleLightbox}
                    >
                      {mainImage.length > 0 ? (
                        <Fragment>
                          <img
                            src={mainImage}
                            alt="varaint-img"
                            // data-variant-id={mainImage.variantId}
                            // data-color={mainImage.initial_color}
                            className="main-image-image"
                          />

                          {/* {isDailyDeal ? (
                                        <Ribbon
                                            ribbonWidth="280px"
                                            text="Daily Deal 50% Off"
                                            backgroundColor="#AC7060"
                                        />
                                    ) : null} */}

                          {/* {isRibbon ? (
                                        <div className="ribbon trunk-sale-ribbon">
                                            <BF30OffInCart />
                                        </div>
                                    ) : null} */}
                          {/* {isTrunkSale ? (
                                        <div className="ribbon trunk-sale-ribbon">
                                            <Plus25Ribbon />
                                        </div>
                                    ) : null} */}

                          {/* {isBundle ? (
                                        <div className="ribbon final-few-ribbon">
                                            <BF30OffInCart />
                                        </div>
                                    ) : null} */}

                          {/* {isBundle && (
                        <div className="ribbon trunk-sale-ribbon">
                          <BundleRibbon ribbon={bundleRibbons[isBundle]} />
                        </div>
                      )} */}

                          {/* {isFinalFew ? (
                                        <div className="ribbon final-few-ribbon">
                                            <BF30OffInCart />
                                        </div>
                                    ) : null} */}

                          {/* {isUPF50 && (
                        <div className="product-flag">
                          <UPF50 />
                        </div>
                      )} */}
                        </Fragment>
                      ) : (
                        <div className="loading">Loading</div>
                      )}
                    </div>
                  </div>
                  <div className="image-instruction">
                    Hover to zoom or click to view full image larger
                  </div>
                </div>
                <div className="product-content-outer">
                  <div className="product-content-inner">
                    <div className="product-header">
                      <h1 className="product-title">
                        {productTitle.split("_")[0].replace("[hidden]", "")}
                      </h1>
                    </div>
                    <div className="product-price">
                      {price.length && price[activeVariant] && (
                        <span className="price">
                          ${convertToCurrency(price[activeVariant])}
                        </span>
                      )}
                    </div>
                    <div className="alternate-payments"></div>
                    <div className="product-actions product-actions-outer">
                      <div className="product-actions-inner">
                        <div className="product-add-to-cart">
                          <div className="product-add-to-cart">
                            <button
                              id="open-cart-drawer"
                              className="hidden visually-hidden open-drawer"
                            >
                              Open Cart
                            </button>
                            <form
                              //   action={`${
                              //     productOptions.embroidery === false
                              //       ? "/cart/add"
                              //       : ""
                              //   }`}
                              acceptCharset="UTF-8"
                              encType="multipart/form-data"
                              className="product-atc"
                            >
                              <Fragment>
                                <input
                                  type="hidden"
                                  min="1"
                                  name="quantity"
                                  value={1}
                                />
                                <input
                                  type="hidden"
                                  name="id"
                                  id="variant-id"
                                  //   value={
                                  //     currentSize.variantId
                                  //       ? currentSize.variantId
                                  //       : variants.length > 0
                                  //       ? variants[0].id
                                  //       : ""
                                  //   }
                                />
                              </Fragment>
                              <img
                                src="https://tags.srv.stackadapt.com/conv?cid=qBKDsUM8E94E9aNhrIzfYt"
                                width="1"
                                height="1"
                              />
                              <button
                                type={false ? null : "submit"}
                                className={`large-button button-atc ${
                                  !currentSize.size ? "disabled" : ""
                                }`}
                                // data-balloon-blunt
                                data-balloon-pos="up"
                                aria-label={
                                  !currentSize.size
                                    ? "Please select a size"
                                    : null
                                }
                                onClick={(e) => handleAddToCart(e)}
                              >
                                Add To Cart
                              </button>
                            </form>
                          </div>
                        </div>
                        <div className="product-add-to-registry">
                          <div className="registry-actions">
                            <span
                              className={`large-button button-atc registry-btn ${
                                !currentSize.size ? "disabled" : null
                              }`}
                              //   data-variant-id={currentSize.variantId}
                              data-balloon-blunt
                              data-balloon-pos="up"
                              aria-label={true ? "Please select a size" : null}
                              //   onClick={() => {
                              //     if (!currentSize.size) {
                              //       nullFunction();
                              //     } else {
                              //       addProductToRegistry(
                              //         productTitle
                              //           .split("_")[0]
                              //           .replace("[hidden]", ""),
                              //         mainImage ? mainImage.src : null,
                              //         currentSize.variantId,
                              //         quantity
                              //       );
                              //     }
                              //   }}
                            >
                              Add To Registry
                            </span>
                          </div>
                        </div>
                      </div>
                    </div>

                    {varaintColor.length > 0 && (
                      <div className="product-swatches">
                        <div className="current-color-text">
                          Selected Color:{" "}
                          <span className="current-color-text-text">
                            {varaintColor[activeVariant]}
                          </span>
                        </div>

                        <div className="color-section">
                          <div className="color-text">Basics: </div>
                          <ul
                            ref={inputRef}
                            className="swatch-list pattern-list nostyle"
                          >
                            {varaintColor.map((s, i) => {
                              // console.log(
                              //     's',
                              //     s,
                              //     sortedColors.basic
                              if (s) {
                                const swatchSlug = slugify(s);
                                return (
                                  <li
                                    key={swatchSlug}
                                    className={`swatch swatch-item ${
                                      activeVariant === i
                                        ? "swatch-selected"
                                        : ""
                                    }`}
                                    data-swatch-index={i}
                                    data-swatch-color={swatchSlug}
                                    aria-label={s}
                                    data-balloon-pos="up"
                                    onClick={() => {
                                      setActiveVariant(i);
                                      setMainImage(allVariantImages[i][0]);

                                      let imageSelected =
                                        document.querySelector(
                                          ".image-selected"
                                        );

                                      imageSelected.classList.remove(
                                        "image-selected"
                                      );

                                      // find matching image node; add class
                                      setTimeout(() => {
                                        let matchingImageNode =
                                          document.querySelector(
                                            '[data-index="' + `${i}${0}` + '"]'
                                          );
                                        matchingImageNode.classList.add(
                                          "image-selected"
                                        );
                                      }, 500);
                                    }}
                                  >
                                    <div className="swatch-image">
                                      <img
                                        src={`${FILES_URL}maswatch-${swatchSlug}-96.png`}
                                        alt={s.color}
                                      />
                                    </div>
                                  </li>
                                );
                              }
                            })}
                          </ul>
                        </div>
                      </div>
                    )}

                    {/*{soldOutSelected.isSoldOut && isDisney && (
                  <div className="disney-waitlist-outer">
                    <div className="disney-waitlist-inner">
                      <span
                        className="disney-waitlist-close"
                        onClick={closeWaitlistForm}
                      >
                        &times;
                      </span>
                      <div className="disney-waitlist-content">
                        <h2>Get notified if product is back in stock</h2>
                        <p>
                          Product:{" "}
                          {hiddenProduct[0].title.replace("[hidden]", "")}
                        </p>
                        <p>Color: {currentColor}</p>
                        <p>Size: {soldOutSelected.variantSize}</p>
                        <form id="disney-waitlist-form" action="/">
                          <label
                            id="disney-waitlist-email-label"
                            htmlFor="disney-waitlist-email"
                          >
                            Email Address{" "}
                            <span className="required">(required)</span>
                            <input
                              type="email"
                              name="email"
                              id="disney-waitlist-email"
                              required
                            />
                          </label>

                          <p className="disney-waitlist-terms">
                            * By submitting this form you are agreeing to
                            receive marketing and promotional emails from Monica
                            + Andy. You may unsubscribe or opt-out at any time.
                            You will still receive a message if the item you
                            submitted is back in stock.
                          </p>

                          <button
                            className="large-button primary-button"
                            type="submit"
                            onClick={(e) => handleWaitlistSubmit(e)}
                          >
                            Notify Me
                          </button>
                        </form>
                      </div>
                      <div className="disney-waitlist-success">
                        <h2>You'll get notified!</h2>
                        <p>Thanks for submitting.</p>
                      </div>
                    </div>
                  </div>
                )} */}

                    <div className="product-sizes">
                      {sizeArray.length && sizeArray[activeVariant] ? (
                        <Fragment>
                          <div className="size-text">
                            Size:{" "}
                            <span className="current-size-text">
                              {currentSize.size && currentSize.size !== "nosize"
                                ? currentSize.size
                                : ""}
                            </span>
                            {/* {isDisney && (
                          <span className="oos-text">
                            Click/tap on an out-of-stock size to get notified if
                            it is back in stock.
                          </span>
                        )} */}
                          </div>
                          <ul className="size-list nostyle">
                            {sizeArray[activeVariant][0].map((s, i) => {
                              // console.log('s', s)
                              if (s.initial_size) {
                                return (
                                  <li
                                    key={s.initial_size}
                                    className={`size ${
                                      currentSize.size &&
                                      currentSize.size === s.initial_size
                                        ? "size-selected"
                                        : ""
                                    } ${
                                      s.inventory_quantity === 0
                                        ? "size-out-of-stock pointer-none"
                                        : ""
                                    }`}
                                    onClick={() =>
                                      handleSizeClick(
                                        s.initial_size,
                                        s.variantId,
                                        i,
                                        s.sku,
                                        s.inventory_quantity
                                      )
                                    }
                                    // data-variant-id={s.variantId}
                                    // aria-label={
                                    //   s.inventory_quantity === 0 && isDisney
                                    //     ? "Click to get notified when back in stock"
                                    //     : null
                                    // }
                                    data-balloon-pos="up"
                                  >
                                    <span className="size-label">
                                      {s.initial_size}
                                    </span>
                                  </li>
                                );
                              }
                              return null;
                            })}
                          </ul>
                          <SizeGuide />
                        </Fragment>
                      ) : null}
                    </div>

                    {/* {embroidery && (
                  <Embroidery
                    productOptions={productOptions}
                    setProductOptions={setProductOptions}
                    handleOptions={handleOptions}
                    clearOptions={clearOptions}
                    productHandle={hiddenProduct && hiddenProduct[0].handle}
                  />
                )} */}

                    <div className="product-description">
                      {/* {!noGots ? ( */}
                      <div className="gots-certified-logo">
                        <img
                          src="https://cdn.shopify.com/s/files/1/2338/2917/files/gots-pdp-label_2x_47427d89-ebd8-4dd0-bcf7-9bf036469ed2.png?v=1663862365"
                          alt="GOTS Certified Logo"
                          className="gots-certified-logo-img"
                        />
                      </div>
                      {/* ) : null} */}

                      <div className="product-desc">
                        Say hello to baby’s first collared shirt. Dress it up or
                        down. Our Limited Edition prints add some fun; a pocket
                        detail adds a dash of charm. • 100% organic cotton •
                        pocket detail + buttons down the front for easy on and
                        off • lead, phthalate, and flame-retardant free • GOTS
                        certified; the leading environmental standard for
                        organic textiles • machine wash; tumble dry low
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>

            <div id="findmine-app-container" />

            {/* {mainProduct &&
          mainProduct[0] &&
          mainProduct[0].vendor === "Monica + Andy" &&
          slug && (
            <div className="below-product-outer">
              <div className="below-product-inner">
                {slug.indexOf("disney-princess") === -1 &&
                (slug.indexOf("pajamas") > -1 ||
                  slug.indexOf("sleep-bags") > -1) ? (
                  <Fragment>
                    <ShopMore
                      queryType="print"
                      shopMoreTitle="Shop More Styles"
                      mainProduct={mainProduct}
                    />
                  </Fragment>
                ) : null}
              </div>
            </div>
          )} */}

            {/* <div className="product-reviews-outer">
          <div className="product-reviews-inner">
            {slug && slug.indexOf("disney-princess-double-ruffle") > -1 ? (
              <div
                data-bv-show="reviews"
                data-bv-product-id="6933496070206"
              ></div>
            ) : (
              <div
                data-bv-show="reviews"
                data-bv-product-id={
                  hiddenProduct && hiddenProduct[0]
                    ? hiddenProduct[0].id
                    : mainProduct && mainProduct[0]
                    ? mainProduct[0].id
                    : currentProduct && currentProduct[0]
                    ? currentProduct[0].id
                    : null
                }
              ></div>
            )}
          </div>
        </div> */}
            {/* <ErrorBoundary FallbackComponent={ErrorHandler}>
          <Schema
            mainProduct={mainProduct}
            productTitle={productTitle}
            productDescription={productDescription}
            sku={currentSize.sku}
            mainImage={mainImage}
            currentPrice={currentPrice}
          />
        </ErrorBoundary> */}
          </Fragment>
        )}
      </>
    );
  }
);

export default BundleProduct;
